// CAP-937: per-make deny-list for BRP consumer prequal links (?make=...).
// The backend flex vehicle_types allow-list returns asset types a given BRP
// brand does not actually manufacture, so the make-filtered links surface
// tiles like PWC/Snow under Can-Am. This map suppresses those tiles per brand
// on top of the global BRP deny-list. Keyed by the ?make= slug (lowercased);
// values are vehicles-types.json ids. Marketing add/remove is a one-line edit.
export const BRP_MAKE_HIDDEN_VEHICLE_TYPES = Object.freeze({
   "ski-doo": Object.freeze(["pwc", "motorcycle"]),
   "sea-doo": Object.freeze(["snowmobile", "trailer"]),
   "can-am": Object.freeze(["pwc", "snowmobile"]),
});

/**
 * Vehicle-type ids the given make must not show, or [] when the make has no
 * per-make deny-list. Match is case-insensitive on the ?make= slug.
 * @param {string} make
 * @returns {readonly string[]}
 */
export const getHiddenVehicleTypesForMake = (make) => {
   if (!make) return [];
   return BRP_MAKE_HIDDEN_VEHICLE_TYPES[make.toLowerCase()] ?? [];
};
